// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-hero .wrapper-intro,
.srprs-hero .wrapper-visual {
  color: var(--colorForegroundAccent);
}
.srprs-hero .wrapper-visual {
  overflow: hidden;
}
.srprs-hero .wrapper-visual .wrapper-inner {
  width: 100%;
}
.srprs-hero .wrapper-visual picture {
  height: 200px;
}
.srprs-hero .wrapper-visual figcaption {
  padding-right: calc(constant(safe-area-inset-right));
}
.srprs-hero .wrapper-visual img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.srprs-hero.type-slim .wrapper-intro, .srprs-hero.type-tall-slim .wrapper-intro, .srprs-hero.type-specials .wrapper-intro {
  z-index: 2;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  color: #fff;
  text-shadow: 0 2px 2px rgba(34, 34, 34, 0.75);
}
.srprs-hero.type-slim .wrapper-visual, .srprs-hero.type-tall-slim .wrapper-visual, .srprs-hero.type-specials .wrapper-visual, .srprs-hero.type-entry .wrapper-visual, .srprs-hero.type-logo-tall .wrapper-visual, .srprs-hero.type-logo .wrapper-visual {
  z-index: 1;
  position: relative;
  height: 120vw;
  margin-top: 0;
}
.srprs-hero.type-slim .wrapper-visual .wrapper-inner, .srprs-hero.type-tall-slim .wrapper-visual .wrapper-inner, .srprs-hero.type-specials .wrapper-visual .wrapper-inner, .srprs-hero.type-entry .wrapper-visual .wrapper-inner, .srprs-hero.type-logo-tall .wrapper-visual .wrapper-inner, .srprs-hero.type-logo .wrapper-visual .wrapper-inner {
  height: 100%;
}
.srprs-hero.type-slim .wrapper-highlight > .wrapper-inner, .srprs-hero.type-tall-slim .wrapper-highlight > .wrapper-inner, .srprs-hero.type-specials .wrapper-highlight > .wrapper-inner, .srprs-hero.type-entry .wrapper-highlight > .wrapper-inner, .srprs-hero.type-logo-tall .wrapper-highlight > .wrapper-inner, .srprs-hero.type-logo .wrapper-highlight > .wrapper-inner {
  text-align: center;
  margin: auto;
}
.srprs-hero.type-slim .wrapper-highlight > .wrapper-inner .heading-wrapper, .srprs-hero.type-tall-slim .wrapper-highlight > .wrapper-inner .heading-wrapper, .srprs-hero.type-specials .wrapper-highlight > .wrapper-inner .heading-wrapper, .srprs-hero.type-entry .wrapper-highlight > .wrapper-inner .heading-wrapper, .srprs-hero.type-logo-tall .wrapper-highlight > .wrapper-inner .heading-wrapper, .srprs-hero.type-logo .wrapper-highlight > .wrapper-inner .heading-wrapper {
  color: #fff;
  margin: auto;
  text-align: left;
}
.srprs-hero.type-slim .wrapper-highlight > .wrapper-inner .heading-wrapper *, .srprs-hero.type-tall-slim .wrapper-highlight > .wrapper-inner .heading-wrapper *, .srprs-hero.type-specials .wrapper-highlight > .wrapper-inner .heading-wrapper *, .srprs-hero.type-entry .wrapper-highlight > .wrapper-inner .heading-wrapper *, .srprs-hero.type-logo-tall .wrapper-highlight > .wrapper-inner .heading-wrapper *, .srprs-hero.type-logo .wrapper-highlight > .wrapper-inner .heading-wrapper * {
  color: #fff;
}
.srprs-hero.type-slim .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading, .srprs-hero.type-tall-slim .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading, .srprs-hero.type-specials .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading, .srprs-hero.type-entry .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading, .srprs-hero.type-logo-tall .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading, .srprs-hero.type-logo .wrapper-highlight > .wrapper-inner .heading-wrapper .srprs-heading {
  text-align: left;
}
.srprs-hero.type-slim .header-subheading, .srprs-hero.type-tall-slim .header-subheading, .srprs-hero.type-specials .header-subheading, .srprs-hero.type-entry .header-subheading, .srprs-hero.type-logo-tall .header-subheading, .srprs-hero.type-logo .header-subheading {
  margin-bottom: 60px;
}
.srprs-hero.type-slim .wrapper-intro {
  margin-top: -75px;
}
.srprs-hero.type-slim .wrapper-highlight {
  display: none;
}
.srprs-hero.type-specials .wrapper-intro, .srprs-hero.type-tall-slim .wrapper-intro {
  margin-top: -261px;
  margin-bottom: -5px;
}
.srprs-hero.type-specials .wrapper-highlight, .srprs-hero.type-tall-slim .wrapper-highlight {
  z-index: 2;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
}
.srprs-hero.type-tall-slim .wrapper-intro {
  margin-top: -114px;
}
.srprs-hero.type-tall-slim h1.srprs-heading {
  font-size: 22px;
  min-height: 48px;
}
.srprs-hero.type-entry .wrapper-visual, .srprs-hero.type-logo-tall .wrapper-visual, .srprs-hero.type-flavour-entry .wrapper-visual, .srprs-hero.type-logo .wrapper-visual {
  height: 700px;
}
.srprs-hero.type-entry.colour-white .srprs-heading,
.srprs-hero.type-entry.colour-white .srprs-breadcrumbs, .srprs-hero.type-logo-tall.colour-white .srprs-heading,
.srprs-hero.type-logo-tall.colour-white .srprs-breadcrumbs, .srprs-hero.type-flavour-entry.colour-white .srprs-heading,
.srprs-hero.type-flavour-entry.colour-white .srprs-breadcrumbs, .srprs-hero.type-logo.colour-white .srprs-heading,
.srprs-hero.type-logo.colour-white .srprs-breadcrumbs {
  color: #fff;
}
.srprs-hero.type-entry.colour-black .srprs-heading,
.srprs-hero.type-entry.colour-black .srprs-breadcrumbs, .srprs-hero.type-logo-tall.colour-black .srprs-heading,
.srprs-hero.type-logo-tall.colour-black .srprs-breadcrumbs, .srprs-hero.type-flavour-entry.colour-black .srprs-heading,
.srprs-hero.type-flavour-entry.colour-black .srprs-breadcrumbs, .srprs-hero.type-logo.colour-black .srprs-heading,
.srprs-hero.type-logo.colour-black .srprs-breadcrumbs {
  color: #222;
}
.srprs-hero.type-entry.type-logo-tall, .srprs-hero.type-logo-tall.type-logo-tall, .srprs-hero.type-flavour-entry.type-logo-tall, .srprs-hero.type-logo.type-logo-tall {
  height: 700px;
}
.srprs-hero.type-entry .wrapper-highlight, .srprs-hero.type-logo-tall .wrapper-highlight, .srprs-hero.type-flavour-entry .wrapper-highlight, .srprs-hero.type-logo .wrapper-highlight {
  z-index: 2;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: -600px;
}
.srprs-hero.type-flavour-entry .wrapper-visual {
  z-index: 0;
  height: 850px;
}
.srprs-hero.type-flavour-entry .wrapper-highlight {
  margin-top: -750px;
}
.srprs-hero.type-funnel, .srprs-hero.type-entries, .srprs-hero.type-card-entries, .srprs-hero.type-card-entries-plain {
  background-color: #fff;
}
.srprs-hero.type-funnel .wrapper-intro, .srprs-hero.type-entries .wrapper-intro, .srprs-hero.type-card-entries .wrapper-intro, .srprs-hero.type-card-entries-plain .wrapper-intro {
  color: #222;
  padding-top: 76px;
  padding-left: 20px;
  padding-right: 20px;
}
.srprs-hero.type-funnel .wrapper-intro .under-heading, .srprs-hero.type-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries-plain .wrapper-intro .under-heading {
  padding-top: 4px;
  padding-bottom: 10px;
}
.srprs-hero.type-funnel .wrapper-intro .under-heading > div, .srprs-hero.type-entries .wrapper-intro .under-heading > div, .srprs-hero.type-card-entries .wrapper-intro .under-heading > div, .srprs-hero.type-card-entries-plain .wrapper-intro .under-heading > div {
  margin-bottom: 1.5em;
  margin-top: 0;
  line-height: 1.375em;
}
.srprs-hero.type-funnel .wrapper-highlight, .srprs-hero.type-entries .wrapper-highlight, .srprs-hero.type-card-entries .wrapper-highlight, .srprs-hero.type-card-entries-plain .wrapper-highlight {
  position: relative;
  z-index: 3;
  padding-right: 10px;
  padding-left: 10px;
}
.srprs-hero.type-funnel .wrapper-visual {
  z-index: 2;
  height: 66.6666666667vw;
  margin-top: -40px;
}
.srprs-hero.type-funnel .wrapper-visual .wrapper-inner {
  height: 100%;
}
.srprs-hero.type-entries .wrapper-lower, .srprs-hero.type-card-entries .wrapper-lower, .srprs-hero.type-card-entries-plain .wrapper-lower {
  position: relative;
  z-index: 2;
  margin-top: 0;
  margin-bottom: 0;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-button, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-button, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-button {
  text-align: center;
  padding-bottom: 80px;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-button button.srprs-button, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-button button.srprs-button, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-button button.srprs-button {
  height: 45px;
  line-height: calc(45px - 2 * var(--borderWidth));
  font-size: 16px;
  font-weight: bold;
  padding-left: 40px;
  padding-right: 40px;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-link, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-link, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-link {
  text-align: right;
  padding-top: 70px;
  padding-right: 20px;
  width: 100%;
  max-width: 1156px;
  margin: 0 auto;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-link button, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-link button, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-link button {
  color: #222222;
  font-size: 15px;
  text-transform: none;
  text-decoration: underline;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-link .show-more-label, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-link .show-more-label, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-link .show-more-label {
  text-align: left;
  z-index: 1;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-show-more-link .show-more-label p, .srprs-hero.type-card-entries .wrapper-lower .wrapper-show-more-link .show-more-label p, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-link .show-more-label p {
  color: #222222;
  font-size: 18px;
  font-weight: bold;
  padding: 0 20px;
  line-height: 50px;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-background, .srprs-hero.type-card-entries .wrapper-lower .wrapper-background, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-background {
  position: absolute;
  top: 0;
  z-index: 0;
  height: 100%;
  width: 100%;
  background-color: #f6fffe;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-background .srprs-photo, .srprs-hero.type-card-entries .wrapper-lower .wrapper-background .srprs-photo, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-background .srprs-photo {
  position: absolute;
  top: auto;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-entry, .srprs-hero.type-card-entries .wrapper-lower .wrapper-entry, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-entry {
  padding-top: 0;
  padding-bottom: 40px;
  width: 100%;
  max-width: 1156px;
  bottom: 350px;
  margin: 0 auto;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-visual {
  height: 100vw;
}
.srprs-hero.type-entries .wrapper-lower .wrapper-visual .wrapper-inner, .srprs-hero.type-card-entries .wrapper-lower .wrapper-visual .wrapper-inner, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-visual .wrapper-inner {
  height: 100%;
}
.srprs-hero.type-card-entries-plain .srprs-heading.is-alternative {
  font-weight: 400;
}
.srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-show-more-link .show-more-label p.show-more-label-title {
  font-weight: 400;
  text-transform: none;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0;
}
.srprs-hero.type-flat-image {
  position: relative;
}
.srprs-hero.type-flat-image .wrapper-visual,
.srprs-hero.type-flat-image .wrapper-intro {
  height: 500px;
  background-color: transparent;
}
.srprs-hero.type-flat-image .wrapper-intro {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.srprs-hero.type-flat-image .wrapper-intro .wrapper-inner {
  max-width: 1280px;
  width: calc(100% - 40px);
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.srprs-hero.type-flat-image .wrapper-intro .under-heading,
.srprs-hero.type-flat-image .wrapper-intro .srprs-heading {
  text-transform: unset;
  color: #fff;
}
.srprs-hero.type-flat-image .wrapper-visual {
  z-index: 1;
  margin-top: 0;
}
.srprs-hero.type-flat-image .wrapper-visual .wrapper-inner {
  height: 100%;
}
.srprs-hero.type-flat-image.colour-white .srprs-heading,
.srprs-hero.type-flat-image.colour-white .srprs-breadcrumbs {
  color: #fff;
}
.srprs-hero.type-flat-image.colour-black .srprs-heading,
.srprs-hero.type-flat-image.colour-black .srprs-breadcrumbs {
  color: #222;
}
.srprs-hero.type-flat-image .wrapper-highlight {
  z-index: 2;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: 375px) {
  .srprs-hero.type-slim .wrapper-visual {
    height: 60vh;
  }
  .srprs-hero.type-slim .wrapper-intro {
    margin-top: -278px;
  }
  .srprs-hero.type-specials .wrapper-intro {
    margin-top: -278px;
  }
  .srprs-hero.type-tall-slim .wrapper-intro {
    margin-top: -88px;
  }
  .srprs-hero.type-entries .wrapper-lower {
    padding-bottom: 40px;
  }
  .srprs-hero.type-card-entries .wrapper-intro, .srprs-hero.type-card-entries-plain .wrapper-intro {
    margin-top: 0;
  }
  .srprs-hero.type-card-entries .wrapper-lower, .srprs-hero.type-card-entries-plain .wrapper-lower {
    padding-bottom: 10px;
  }
}
@media screen and (min-width: 768px) {
  .srprs-hero.type-slim .wrapper-intro {
    padding-left: 20px;
    padding-right: 40px;
    margin-top: -92px;
  }
  .srprs-hero.type-slim .wrapper-visual {
    height: 40vh;
  }
  .srprs-hero.type-specials .wrapper-intro, .srprs-hero.type-tall-slim .wrapper-intro {
    padding-left: 40px;
    padding-right: 40px;
    margin-top: -166px;
  }
  .srprs-hero.type-specials .wrapper-highlight, .srprs-hero.type-tall-slim .wrapper-highlight {
    padding-left: 20px;
    padding-right: 20px;
  }
  .srprs-hero.type-specials .wrapper-visual, .srprs-hero.type-tall-slim .wrapper-visual {
    height: 100vw;
  }
  .srprs-hero.type-tall-slim h1.srprs-heading {
    font-size: 42px;
  }
  .srprs-hero.type-entry .wrapper-highlight {
    padding-left: 0;
    padding-right: 0;
    margin-top: -466px;
  }
  .srprs-hero.type-entry.type-flavour-entry .wrapper-highlight {
    margin-top: -200px;
  }
  .srprs-hero.type-entry .wrapper-visual {
    height: 40vw;
  }
  .srprs-hero.type-funnel .wrapper-intro, .srprs-hero.type-entries .wrapper-intro, .srprs-hero.type-card-entries .wrapper-intro, .srprs-hero.type-card-entries-plain .wrapper-intro {
    padding-top: 96px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 10px;
  }
  .srprs-hero.type-funnel .wrapper-intro .under-heading, .srprs-hero.type-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries-plain .wrapper-intro .under-heading {
    padding-top: 6px;
  }
  .srprs-hero.type-funnel .wrapper-visual, .srprs-hero.type-entries .wrapper-visual, .srprs-hero.type-card-entries .wrapper-visual, .srprs-hero.type-card-entries-plain .wrapper-visual {
    height: 50vw;
  }
  .srprs-hero.type-entries .wrapper-lower, .srprs-hero.type-card-entries .wrapper-lower, .srprs-hero.type-card-entries-plain .wrapper-lower {
    padding-bottom: 200px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-background .wrapper-white, .srprs-hero.type-card-entries .wrapper-lower .wrapper-background .wrapper-white, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-background .wrapper-white {
    height: 570px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-visual {
    height: 50vw;
  }
  .srprs-hero.type-flat-image .wrapper-intro,
  .srprs-hero.type-flat-image .wrapper-visual {
    min-height: 620px;
    height: 50vh;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-hero.type-slim .wrapper-intro {
    max-width: 880px;
    margin: 0 auto;
    padding-left: 0;
    padding-right: 0;
    margin-top: -112px;
  }
  .srprs-hero.type-specials .wrapper-intro, .srprs-hero.type-tall-slim .wrapper-intro {
    max-width: 880px;
    margin: 0 auto;
    padding-left: 0;
    padding-right: 0;
    margin-top: -166px;
  }
  .srprs-hero.type-specials .wrapper-highlight, .srprs-hero.type-tall-slim .wrapper-highlight {
    max-width: 880px;
    margin: 0 auto;
    padding-left: 0;
    padding-right: 0;
  }
  .srprs-hero.type-specials .wrapper-visual, .srprs-hero.type-tall-slim .wrapper-visual {
    height: 50vw;
  }
  .srprs-hero.type-entry .wrapper-highlight {
    max-width: 706px;
    margin-left: auto;
    margin-right: auto;
  }
  .srprs-hero.type-logo-tall .heading-wrapper, .srprs-hero.type-logo .heading-wrapper {
    max-width: 1010px;
  }
  .srprs-hero.type-logo-tall .wrapper-highlight, .srprs-hero.type-logo .wrapper-highlight {
    max-width: 1140px;
    margin-top: -400px;
    margin-left: auto;
    margin-right: auto;
  }
  .srprs-hero.type-funnel .wrapper-intro, .srprs-hero.type-entries .wrapper-intro, .srprs-hero.type-card-entries .wrapper-intro, .srprs-hero.type-card-entries-plain .wrapper-intro {
    max-width: 966px;
    margin: 0 auto;
    padding-top: 106px;
    padding-left: 0;
    padding-right: 0;
  }
  .srprs-hero.type-funnel .wrapper-intro .under-heading, .srprs-hero.type-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries-plain .wrapper-intro .under-heading {
    padding-top: 16px;
  }
  .srprs-hero.type-funnel .wrapper-highlight, .srprs-hero.type-entries .wrapper-highlight, .srprs-hero.type-card-entries .wrapper-highlight, .srprs-hero.type-card-entries-plain .wrapper-highlight {
    padding-left: 0;
    padding-right: 0;
  }
  .srprs-hero.type-funnel .wrapper-highlight .wrapper-inner, .srprs-hero.type-entries .wrapper-highlight .wrapper-inner, .srprs-hero.type-card-entries .wrapper-highlight .wrapper-inner, .srprs-hero.type-card-entries-plain .wrapper-highlight .wrapper-inner {
    max-width: 966px;
    margin: 0 auto;
  }
  .srprs-hero.type-flat-image .wrapper-intro {
    padding: 0 75px;
  }
}
@media screen and (min-width: 1280px) {
  .srprs-hero.type-slim .wrapper-intro {
    margin-top: -134px;
  }
  .srprs-hero.type-slim .wrapper-visual {
    height: 500px;
  }
  .srprs-hero.type-specials .wrapper-intro, .srprs-hero.type-tall-slim .wrapper-intro {
    margin-top: -186px;
    margin-bottom: -10px;
  }
  .srprs-hero.type-specials .wrapper-highlight, .srprs-hero.type-tall-slim .wrapper-highlight {
    margin-bottom: -40px;
  }
  .srprs-hero.type-specials .wrapper-visual, .srprs-hero.type-tall-slim .wrapper-visual {
    height: 33.3333333333vw;
  }
  .srprs-hero.type-tall-slim h1.srprs-heading {
    font-size: 54px;
  }
  .srprs-hero.type-flavour-entry h1.srprs-heading {
    font-size: 36px;
    font-weight: 800;
    text-align: left;
    padding-bottom: 20px;
  }
  .srprs-hero.type-entry {
    min-height: 500px;
  }
  .srprs-hero.type-entry .wrapper-visual {
    height: 500px;
  }
  .srprs-hero.type-logo-tall .wrapper-highlight, .srprs-hero.type-logo .wrapper-highlight {
    margin-top: -480px;
  }
  .srprs-hero.type-funnel .wrapper-intro, .srprs-hero.type-entries .wrapper-intro, .srprs-hero.type-card-entries .wrapper-intro, .srprs-hero.type-card-entries-plain .wrapper-intro {
    padding-top: 76px;
  }
  .srprs-hero.type-funnel .wrapper-intro .under-heading, .srprs-hero.type-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries .wrapper-intro .under-heading, .srprs-hero.type-card-entries-plain .wrapper-intro .under-heading {
    padding-top: 20px;
  }
  .srprs-hero.type-funnel .wrapper-visual, .srprs-hero.type-entries .wrapper-visual, .srprs-hero.type-card-entries .wrapper-visual, .srprs-hero.type-card-entries-plain .wrapper-visual {
    height: 33.3333333333vw;
  }
  .srprs-hero.type-entries .wrapper-lower {
    padding-bottom: 500px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-show-more-link {
    padding-top: 115px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-entry {
    padding-top: 0;
    padding-bottom: 38px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-visual {
    height: 33.3333333333vw;
  }
}
@media screen and (min-width: 1600px) {
  .srprs-hero.type-specials .wrapper-visual, .srprs-hero.type-funnel .wrapper-visual {
    height: 500px;
  }
  .srprs-hero.type-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries .wrapper-lower .wrapper-visual, .srprs-hero.type-card-entries-plain .wrapper-lower .wrapper-visual {
    height: 500px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Hero/Hero.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transform-center.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AApME;;EAEE,mCAAA;AAsMJ;AApME;EACE,gBAAA;AAsMJ;AArMI;EACE,WAAA;AAuMN;AArMI;EACE,aAAA;AAuMN;AArMI;EACE,oDAAA;AAuMN;AArMI;EIjBF,kBAAA;EAEE,QAHgC;EAOlC,SAAA;EACA,gCAAA;AJqNF;AApMI;EACE,UAAA;EACA,kBAAA;EAEE,kBAAA;EACA,mBAAA;EAEF,WAAA;EACA,6CAAA;AAoMN;AA1LI;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EAEE,aAAA;AA2LR;AAzLM;EACE,YAAA;AA2LR;AAvLM;EACE,kBAAA;EACA,YAAA;AAyLR;AAvLQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAyLV;AAvLU;EACE,WAAA;AAyLZ;AAtLU;EACE,gBAAA;AAwLZ;AAnLI;EAEI,mBAAA;AAoLR;AA/KI;EAEI,iBAAA;AAgLR;AA7KI;EACE,aAAA;AA+KN;AA1KI;EAEI,kBAAA;EACA,mBAAA;AA2KR;AAxKI;EACE,UAAA;EACA,kBAAA;EAEE,kBAAA;EACA,mBAAA;AAyKR;AApKI;EAEI,kBAAA;AAqKR;AAlKI;EACE,eAAA;EACA,gBAAA;AAoKN;AA7JI;EACE,aAAA;AA+JN;AA5JM;;;;;EAEE,WAAA;AAiKR;AA7JM;;;;;EAEE,WAAA;AAkKR;AA/JI;EACE,aAAA;AAiKN;AA9JI;EACE,UAAA;EACA,kBAAA;EAEE,kBAAA;EACA,mBAAA;EAGA,kBAAA;AA6JR;AAvJI;EACE,UAAA;EACA,aAAA;AAyJN;AAvJI;EAEI,kBAAA;AAwJR;AApJE;EAKI,sBAAA;AAkJN;AAhJI;EACE,WAAA;EAEE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAiJR;AA/IM;EAOI,gBAAA;EACA,oBAAA;AA2IV;AAlJQ;EACE,oBAAA;EACA,aAAA;EACA,oBAAA;AAoJV;AA5II;EACE,kBAAA;EACA,UAAA;EAEE,mBAAA;EACA,kBAAA;AA6IR;AAxII;EACE,UAAA;EACA,uBAAA;EAEE,iBAAA;AAyIR;AAvIM;EACE,YAAA;AAyIR;AAlII;EACE,kBAAA;EACA,UAAA;EAEE,aAAA;EACA,gBAAA;AAmIR;AAjIM;EACE,kBAAA;EAEE,oBAAA;AAkIV;AA/HQ;EACE,YAAA;EACA,gDAAA;EACA,eAAA;EACA,iBAAA;EAEE,kBAAA;EACA,mBAAA;AAgIZ;AA5HM;EACE,iBAAA;EAEE,iBAAA;EACA,mBAAA;EAEF,WAAA;EACA,iBAAA;EACA,cAAA;AA4HR;AA1HQ;EACE,cAAA;EACA,eAAA;EACA,oBAAA;EACA,0BAAA;AA4HV;AA1HQ;EACE,gBAAA;EACA,UAAA;AA4HV;AA1HU;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AA4HZ;AAxHM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EAEE,yBAAA;AAyHV;AAtHQ;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AAwHV;AApHM;EAEI,cAAA;EACA,oBAAA;EAEF,WAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;AAoHR;AAjHM;EACE,aAAA;AAmHR;AAlHQ;EACE,YAAA;AAoHV;AA9GI;EACE,gBAAA;AAgHN;AA3GU;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA6GZ;AAvGE;EACE,kBAAA;AAyGJ;AAvGI;;EAEE,aAAA;EAEE,6BAAA;AAwGR;AArGI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAuGN;AAtGM;EACE,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;AAwGR;AAtGM;;EAEE,qBAAA;EACA,WAAA;AAwGR;AArGI;EACE,UAAA;EAEE,aAAA;AAsGR;AApGM;EACE,YAAA;AAsGR;AAlGM;;EAEE,WAAA;AAoGR;AAhGM;;EAEE,WAAA;AAkGR;AA9FI;EACE,UAAA;EACA,kBAAA;EAEE,kBAAA;EACA,mBAAA;AA+FR;;ACzdI;EDmYE;IACE,YAAA;EA0FN;EAxFI;IAEI,kBAAA;EAyFR;EApFI;IAEI,kBAAA;EAqFR;EAhFI;IAEI,iBAAA;EAiFR;EA5EI;IAEI,oBAAA;EA6ER;EAvEI;IAEI,aAAA;EAwER;EArEI;IAEI,oBAAA;EAsER;AACF;ACjfI;EDobE;IAEI,kBAAA;IACA,mBAAA;IAGA,iBAAA;EA6DR;EA1DI;IACE,YAAA;EA4DN;EAvDI;IAEI,kBAAA;IACA,mBAAA;IAGA,kBAAA;EAsDR;EAnDI;IAEI,kBAAA;IACA,mBAAA;EAoDR;EAjDI;IACE,aAAA;EAmDN;EA/CI;IACE,eAAA;EAiDN;EA7CI;IAEI,eAAA;IACA,gBAAA;IAGA,kBAAA;EA4CR;EAzCI;IAEI,kBAAA;EA0CR;EAvCI;IACE,YAAA;EAyCN;EAjCI;IAEI,iBAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;EAkCR;EAhCM;IAEI,gBAAA;EAiCV;EA7BI;IACE,YAAA;EA+BN;EAzBI;IAEI,qBAAA;EA0BR;EAxBM;IACE,aAAA;EA0BR;EAvBM;IACE,YAAA;EAyBR;EApBI;;IAEE,iBAAA;IACA,YAAA;EAsBN;AACF;AC/iBI;EDiiBE;IACE,gBAAA;IACA,cAAA;IAEE,eAAA;IACA,gBAAA;IAGA,kBAAA;EAcR;EARI;IACE,gBAAA;IACA,cAAA;IAEE,eAAA;IACA,gBAAA;IAGA,kBAAA;EAOR;EAJI;IACE,gBAAA;IACA,cAAA;IAEE,eAAA;IACA,gBAAA;EAKR;EAFI;IACE,YAAA;EAIN;EAAI;IACE,gBAAA;IAEE,iBAAA;IACA,kBAAA;EACR;EAKI;IACE,iBAAA;EAHN;EAKI;IACE,iBAAA;IAEE,kBAAA;IACA,iBAAA;IACA,kBAAA;EAJR;EAaI;IACE,gBAAA;IACA,cAAA;IAEE,kBAAA;IACA,eAAA;IACA,gBAAA;EAZR;EAcM;IAEI,iBAAA;EAbV;EAiBI;IAMI,eAAA;IACA,gBAAA;EApBR;EAcM;IACE,gBAAA;IACA,cAAA;EAZR;EAqBI;IACE,eAAA;EAnBN;AACF;AC3mBI;EDsoBE;IAEI,kBAAA;EAzBR;EA4BI;IACE,aAAA;EA1BN;EA+BI;IAEI,kBAAA;IACA,oBAAA;EA9BR;EAiCI;IAEI,oBAAA;EAhCR;EAmCI;IACE,uBAAA;EAjCN;EAqCI;IACE,eAAA;EAnCN;EAuCI;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,oBAAA;EArCN;EAwCE;IACE,iBAAA;EAtCJ;EAuCI;IACE,aAAA;EArCN;EA2CI;IAEI,kBAAA;EA1CR;EAkDI;IAEI,iBAAA;EAjDR;EAmDM;IAEI,iBAAA;EAlDV;EAsDI;IACE,uBAAA;EApDN;EAwDI;IAEI,qBAAA;EAvDR;EAyDM;IAEI,kBAAA;EAxDV;EA2DM;IAEI,cAAA;IACA,oBAAA;EA1DV;EA6DM;IACE,uBAAA;EA3DR;AACF;ACrqBI;ED0uBE;IACE,aAAA;EAlEN;EAwEI;IACE,aAAA;EAtEN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-hero {\n  .wrapper-intro,\n  .wrapper-visual {\n    color: var(--colorForegroundAccent);\n  }\n  .wrapper-visual {\n    overflow: hidden;\n    .wrapper-inner {\n      width: 100%;\n    }\n    picture {\n      height: 200px;\n    }\n    figcaption {\n      padding-right: calc(constant(safe-area-inset-right));\n    }\n    img {\n      @include transform-center();\n    }\n  }\n  &.type-slim,\n  &.type-tall-slim,\n  &.type-specials {\n    .wrapper-intro {\n      z-index: 2;\n      position: relative;\n      padding: {\n        left: 20px;\n        right: 20px;\n      }\n      color: color(white);\n      text-shadow: 0 2px 2px rgba(color(black), 0.75);\n    }\n  }\n\n  &.type-slim,\n  &.type-tall-slim,\n  &.type-specials,\n  &.type-entry,\n  &.type-logo-tall,\n  &.type-logo {\n    .wrapper-visual {\n      z-index: 1;\n      position: relative;\n      height: calc(100vw * 1.2);\n      margin: {\n        top: 0;\n      }\n      .wrapper-inner {\n        height: 100%;\n      }\n    }\n    .wrapper-highlight {\n      > .wrapper-inner {\n        text-align: center;\n        margin: auto;\n\n        .heading-wrapper {\n          color: color(white);\n          margin: auto;\n          text-align: left;\n\n          * {\n            color: color(white);\n          }\n\n          .srprs-heading {\n            text-align: left;\n          }\n        }\n      }\n    }\n    .header-subheading {\n      margin: {\n        bottom: 60px;\n      }\n    }\n  }\n  &.type-slim {\n    .wrapper-intro {\n      margin: {\n        top: -75px;\n      }\n    }\n    .wrapper-highlight {\n      display: none;\n    }\n  }\n  &.type-specials,\n  &.type-tall-slim {\n    .wrapper-intro {\n      margin: {\n        top: -261px;\n        bottom: -5px;\n      }\n    }\n    .wrapper-highlight {\n      z-index: 2;\n      position: relative;\n      padding: {\n        left: 10px;\n        right: 10px;\n      }\n    }\n  }\n  &.type-tall-slim {\n    .wrapper-intro {\n      margin: {\n        top: -114px;\n      }\n    }\n    h1.srprs-heading {\n      font-size: 22px;\n      min-height: 48px;\n    }\n  }\n  &.type-entry,\n  &.type-logo-tall,\n  &.type-flavour-entry,\n  &.type-logo {\n    .wrapper-visual {\n      height: 700px;\n    }\n    &.colour-white {\n      .srprs-heading,\n      .srprs-breadcrumbs {\n        color: color(white);\n      }\n    }\n    &.colour-black {\n      .srprs-heading,\n      .srprs-breadcrumbs {\n        color: color(black);\n      }\n    }\n    &.type-logo-tall {\n      height: 700px;\n    }\n\n    .wrapper-highlight {\n      z-index: 2;\n      position: relative;\n      padding: {\n        left: 20px;\n        right: 20px;\n      }\n      margin: {\n        top: -600px;\n      }\n    }\n  }\n\n  &.type-flavour-entry {\n    .wrapper-visual {\n      z-index: 0;\n      height: 850px;\n    }\n    .wrapper-highlight {\n      margin: {\n        top: -750px;\n      }\n    }\n  }\n  &.type-funnel,\n  &.type-entries,\n  &.type-card-entries,\n  &.type-card-entries-plain {\n    background: {\n      color: color(white);\n    }\n    .wrapper-intro {\n      color: color(black);\n      padding: {\n        top: 76px;\n        left: 20px;\n        right: 20px;\n      }\n      .under-heading {\n        > div {\n          margin-bottom: 1.5em;\n          margin-top: 0;\n          line-height: 1.375em;\n        }\n        padding: {\n          top: 4px;\n          bottom: 10px;\n        }\n      }\n    }\n    .wrapper-highlight {\n      position: relative;\n      z-index: 3;\n      padding: {\n        right: 10px;\n        left: 10px;\n      }\n    }\n  }\n  &.type-funnel {\n    .wrapper-visual {\n      z-index: 2;\n      height: calc(100vw / 1.5);\n      margin: {\n        top: -40px;\n      }\n      .wrapper-inner {\n        height: 100%;\n      }\n    }\n  }\n  &.type-entries,\n  &.type-card-entries,\n  &.type-card-entries-plain {\n    .wrapper-lower {\n      position: relative;\n      z-index: 2;\n      margin: {\n        top: 0;\n        bottom: 0;\n      }\n      .wrapper-show-more-button {\n        text-align: center;\n        padding: {\n          bottom: 80px;\n        }\n\n        button.srprs-button {\n          height: 45px;\n          line-height: calc(45px - (2 * var(--borderWidth)));\n          font-size: 16px;\n          font-weight: bold;\n          padding: {\n            left: 40px;\n            right: 40px;\n          }\n        }\n      }\n      .wrapper-show-more-link {\n        text-align: right;\n        padding: {\n          top: 70px;\n          right: 20px;\n        }\n        width: 100%;\n        max-width: 1156px;\n        margin: 0 auto;\n\n        button {\n          color: #222222;\n          font-size: 15px;\n          text-transform: none;\n          text-decoration: underline;\n        }\n        .show-more-label {\n          text-align: left;\n          z-index: 1;\n\n          p {\n            color: #222222;\n            font-size: 18px;\n            font-weight: bold;\n            padding: 0 20px;\n            line-height: 50px;\n          }\n        }\n      }\n      .wrapper-background {\n        position: absolute;\n        top: 0;\n        z-index: 0;\n        height: 100%;\n        width: 100%;\n        background: {\n          color: #f6fffe;\n        }\n\n        .srprs-photo {\n          position: absolute;\n          top: auto;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          height: auto;\n        }\n      }\n\n      .wrapper-entry {\n        padding: {\n          top: 0;\n          bottom: 40px;\n        }\n        width: 100%;\n        max-width: 1156px;\n        bottom: 350px;\n        margin: 0 auto;\n      }\n\n      .wrapper-visual {\n        height: 100vw;\n        .wrapper-inner {\n          height: 100%;\n        }\n      }\n    }\n  }\n  &.type-card-entries-plain {\n    .srprs-heading.is-alternative {\n      font-weight: 400;\n    }\n    .wrapper-lower {\n      .wrapper-show-more-link {\n        .show-more-label {\n          p.show-more-label-title {\n            font-weight: 400;\n            text-transform: none;\n            font-size: 30px;\n            color: #333333;\n            letter-spacing: 0;\n          }\n        }\n      }\n    }\n  }\n  &.type-flat-image {\n    position: relative;\n\n    .wrapper-visual,\n    .wrapper-intro {\n      height: 500px;\n      background: {\n        color: transparent;\n      }\n    }\n    .wrapper-intro {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      .wrapper-inner {\n        max-width: 1280px;\n        width: calc(100% - 40px);\n        height: 100%;\n        margin: 0 auto;\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n      }\n      .under-heading,\n      .srprs-heading {\n        text-transform: unset;\n        color: color(white);\n      }\n    }\n    .wrapper-visual {\n      z-index: 1;\n      margin: {\n        top: 0;\n      }\n      .wrapper-inner {\n        height: 100%;\n      }\n    }\n    &.colour-white {\n      .srprs-heading,\n      .srprs-breadcrumbs {\n        color: color(white);\n      }\n    }\n    &.colour-black {\n      .srprs-heading,\n      .srprs-breadcrumbs {\n        color: color(black);\n      }\n    }\n\n    .wrapper-highlight {\n      z-index: 2;\n      position: relative;\n      padding: {\n        left: 20px;\n        right: 20px;\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-hero {\n    &.type-slim {\n      .wrapper-visual {\n        height: 60vh;\n      }\n      .wrapper-intro {\n        margin: {\n          top: -278px;\n        }\n      }\n    }\n    &.type-specials {\n      .wrapper-intro {\n        margin: {\n          top: -278px;\n        }\n      }\n    }\n    &.type-tall-slim {\n      .wrapper-intro {\n        margin: {\n          top: -88px;\n        }\n      }\n    }\n    &.type-entries {\n      .wrapper-lower {\n        padding: {\n          bottom: 40px;\n        }\n      }\n    }\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-intro {\n        margin: {\n          top: 0;\n        }\n      }\n      .wrapper-lower {\n        padding: {\n          bottom: 10px;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-hero {\n    &.type-slim {\n      .wrapper-intro {\n        padding: {\n          left: 20px;\n          right: 40px;\n        }\n        margin: {\n          top: -92px;\n        }\n      }\n      .wrapper-visual {\n        height: 40vh;\n      }\n    }\n    &.type-specials,\n    &.type-tall-slim {\n      .wrapper-intro {\n        padding: {\n          left: 40px;\n          right: 40px;\n        }\n        margin: {\n          top: -166px;\n        }\n      }\n      .wrapper-highlight {\n        padding: {\n          left: 20px;\n          right: 20px;\n        }\n      }\n      .wrapper-visual {\n        height: calc(100vw / 1);\n      }\n    }\n    &.type-tall-slim {\n      h1.srprs-heading {\n        font-size: 42px;\n      }\n    }\n    &.type-entry {\n      .wrapper-highlight {\n        padding: {\n          left: 0;\n          right: 0;\n        }\n        margin: {\n          top: -466px;\n        }\n      }\n      &.type-flavour-entry .wrapper-highlight {\n        margin: {\n          top: -200px;\n        }\n      }\n      .wrapper-visual {\n        height: 40vw;\n      }\n    }\n\n    &.type-funnel,\n    &.type-entries,\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-intro {\n        padding: {\n          top: 96px;\n          left: 40px;\n          right: 40px;\n          bottom: 10px;\n        }\n        .under-heading {\n          padding: {\n            top: 6px;\n          }\n        }\n      }\n      .wrapper-visual {\n        height: calc(100vw / 2);\n      }\n    }\n    &.type-entries,\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-lower {\n        padding: {\n          bottom: 200px;\n        }\n        .wrapper-background .wrapper-white {\n          height: 570px;\n        }\n\n        .wrapper-visual {\n          height: calc(100vw / 2);\n        }\n      }\n    }\n    &.type-flat-image {\n      .wrapper-intro,\n      .wrapper-visual {\n        min-height: 620px;\n        height: calc(100vh / 2);\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-hero {\n    &.type-slim {\n      .wrapper-intro {\n        max-width: section(max-width-s);\n        margin: 0 auto;\n        padding: {\n          left: 0;\n          right: 0;\n        }\n        margin: {\n          top: -112px;\n        }\n      }\n    }\n    &.type-specials,\n    &.type-tall-slim {\n      .wrapper-intro {\n        max-width: section(max-width-s);\n        margin: 0 auto;\n        padding: {\n          left: 0;\n          right: 0;\n        }\n        margin: {\n          top: -166px;\n        }\n      }\n      .wrapper-highlight {\n        max-width: section(max-width-s);\n        margin: 0 auto;\n        padding: {\n          left: 0;\n          right: 0;\n        }\n      }\n      .wrapper-visual {\n        height: calc(100vw / 2);\n      }\n    }\n    &.type-entry {\n      .wrapper-highlight {\n        max-width: section(max-width-xs);\n        margin: {\n          left: auto;\n          right: auto;\n        }\n      }\n    }\n    &.type-logo-tall,\n    &.type-logo {\n      .heading-wrapper {\n        max-width: section(max-width-m);\n      }\n      .wrapper-highlight {\n        max-width: section(max-width-initial);\n        margin: {\n          top: -400px;\n          left: auto;\n          right: auto;\n        }\n      }\n    }\n\n    &.type-funnel,\n    &.type-entries,\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-intro {\n        max-width: section(max-width-homepage);\n        margin: 0 auto;\n        padding: {\n          top: 106px;\n          left: 0;\n          right: 0;\n        }\n        .under-heading {\n          padding: {\n            top: 16px;\n          }\n        }\n      }\n      .wrapper-highlight {\n        .wrapper-inner {\n          max-width: section(max-width-homepage);\n          margin: 0 auto;\n        }\n        padding: {\n          left: 0;\n          right: 0;\n        }\n      }\n    }\n    &.type-flat-image {\n      .wrapper-intro {\n        padding: 0 75px;\n      }\n    }\n  }\n}\n\n@include breakpoint(desktop) {\n  .srprs-hero {\n    &.type-slim {\n      .wrapper-intro {\n        margin: {\n          top: -134px;\n        }\n      }\n      .wrapper-visual {\n        height: 500px;\n      }\n    }\n    &.type-specials,\n    &.type-tall-slim {\n      .wrapper-intro {\n        margin: {\n          top: -186px;\n          bottom: -10px;\n        }\n      }\n      .wrapper-highlight {\n        margin: {\n          bottom: -40px;\n        }\n      }\n      .wrapper-visual {\n        height: calc(100vw / 3);\n      }\n    }\n    &.type-tall-slim {\n      h1.srprs-heading {\n        font-size: 54px;\n      }\n    }\n    &.type-flavour-entry {\n      h1.srprs-heading {\n        font-size: 36px;\n        font-weight: 800;\n        text-align: left;\n        padding-bottom: 20px;\n      }\n    }\n    &.type-entry {\n      min-height: 500px;\n      .wrapper-visual {\n        height: 500px;\n      }\n    }\n\n    &.type-logo-tall,\n    &.type-logo {\n      .wrapper-highlight {\n        margin: {\n          top: -480px;\n        }\n      }\n    }\n    &.type-funnel,\n    &.type-entries,\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-intro {\n        padding: {\n          top: 76px;\n        }\n        .under-heading {\n          padding: {\n            top: 20px;\n          }\n        }\n      }\n      .wrapper-visual {\n        height: calc(100vw / 3);\n      }\n    }\n    &.type-entries {\n      .wrapper-lower {\n        padding: {\n          bottom: 500px;\n        }\n        .wrapper-show-more-link {\n          padding: {\n            top: 115px;\n          }\n        }\n        .wrapper-entry {\n          padding: {\n            top: 0;\n            bottom: 38px;\n          }\n        }\n        .wrapper-visual {\n          height: calc(100vw / 3);\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(cinemadisplay) {\n  .srprs-hero {\n    &.type-specials,\n    &.type-funnel {\n      .wrapper-visual {\n        height: 500px;\n      }\n    }\n    &.type-entries,\n    &.type-card-entries,\n    &.type-card-entries-plain {\n      .wrapper-lower .wrapper-visual {\n        height: 500px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transform-center($offsetTop: 50%) {\n  position: absolute;\n  @if ($offsetTop) {\n    top: $offsetTop;\n  } @else {\n    top: 50%;\n  }\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
